import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Plus, Download, Eye, Search, Calendar, DollarSign, FileText, Filter, Edit, Save, X } from 'lucide-react';
import { socket } from '../Containers/MainContainer';
import { getNextMonthLastDay } from '../utils';

function ProfessionalInvoiceManager() {
    // State management
    const [invoices, setInvoices] = useState([
        {
            id: 1,
            invoice_id: 'INV2025',
            invoice_nr: '001',
            client_name: 'Acme Corporation',
            client_address: '123 Business St, Suite 100',
            client_country: 'United States',
            tax_id: 'US123456789',
            vat_number: 'VAT123456',
            email_address: 'billing@acme.com',
            issue_date: '15/05/2025',
            due_date: '15/06/2025',
            delivery_date: '15/05/2025',
            items: [{
                name: 'Marketing Services for May 2025',
                quantity: 1,
                price: 2500,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '14/05/2025'
            }],
            status: 'paid'
        },
        {
            id: 2,
            invoice_id: 'INV2025',
            invoice_nr: '002',
            client_name: 'Tech Solutions Ltd',
            client_address: '456 Innovation Ave',
            client_country: 'United Kingdom',
            tax_id: 'GB987654321',
            vat_number: 'GB123456789',
            email_address: 'finance@techsolutions.co.uk',
            issue_date: '20/05/2025',
            due_date: '20/06/2025',
            delivery_date: '20/05/2025',
            items: [{
                name: 'Consulting Services for May 2025',
                quantity: 1,
                price: 3200,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '19/05/2025'
            }],
            status: 'pending'
        },
        {
            id: 3,
            invoice_id: 'INV2025',
            invoice_nr: '003',
            client_name: 'Global Enterprises Inc',
            client_address: '789 Corporate Blvd',
            client_country: 'Canada',
            tax_id: 'CA456789123',
            vat_number: '',
            email_address: 'accounting@globalent.ca',
            issue_date: '25/05/2025',
            due_date: '25/06/2025',
            delivery_date: '25/05/2025',
            items: [{
                name: 'Development Services for May 2025',
                quantity: 1,
                price: 4800,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '24/05/2025'
            }],
            status: 'overdue'
        },
        {
            id: 4,
            invoice_id: 'INV2025',
            invoice_nr: '004',
            client_name: 'StartupXYZ',
            client_address: '321 Startup Lane',
            client_country: 'Germany',
            tax_id: 'DE789123456',
            vat_number: 'DE987654321',
            email_address: 'billing@startupxyz.de',
            issue_date: '30/05/2025',
            due_date: '30/06/2025',
            delivery_date: '30/05/2025',
            items: [{
                name: 'Design Services for May 2025',
                quantity: 1,
                price: 1800,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '29/05/2025'
            }],
            status: 'draft'
        },
        {
            id: 5,
            invoice_id: 'INV2025',
            invoice_nr: '005',
            client_name: 'Digital Agency Pro',
            client_address: '654 Creative District',
            client_country: 'Australia',
            tax_id: 'AU123789456',
            vat_number: 'AU456123789',
            email_address: 'finance@digitalagencypro.au',
            issue_date: '02/06/2025',
            due_date: '02/07/2025',
            delivery_date: '02/06/2025',
            items: [{
                name: 'SEO Services for June 2025',
                quantity: 1,
                price: 2200,
                currency: 'USD',
                exchange: 4.95,
                exchange_to: 'RON',
                exchange_date: '01/06/2025'
            }],
            status: 'pending'
        }
    ]);

    const [userProfile, setUserProfile] = useState({})
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const [type, setType] = useState(0)
    const [alert, setAlert] = useState({ show: false, type: '', flagReason: '', code: '', pin: '', id: -1 })
    const [alert2, setAlert2] = useState({ show: false, name: '', reward: 0 })

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
   
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedInvoice, setSelectedInvoice] = useState(0);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingInvoice, setEditingInvoice] = useState(null);
    const [statusFilter, setStatusFilter] = useState('all');
    const [exchangeRates, setExchangeRates] = useState({});
    const [invoiceClients, setInvoiceClients] = useState([
        {
            id: 1,
            name: 'Acme Corporation',
            address: '123 Business St, Suite 100',
            country: 'United States',
            tax_id: 'US123456789',
            vat_number: 'VAT123456',
            email: 'billing@acme.com'
        },
        {
            id: 2,
            name: 'Tech Solutions Ltd',
            address: '456 Innovation Ave',
            country: 'United Kingdom',
            tax_id: 'GB987654321',
            vat_number: 'GB123456789',
            email: 'finance@techsolutions.co.uk'
        },
        {
            id: 3,
            name: 'Global Enterprises Inc',
            address: '789 Corporate Blvd',
            country: 'Canada',
            tax_id: 'CA456789123',
            vat_number: '',
            email: 'accounting@globalent.ca'
        },
        {
            id: 4,
            name: 'StartupXYZ',
            address: '321 Startup Lane',
            country: 'Germany',
            tax_id: 'DE789123456',
            vat_number: 'DE987654321',
            email: 'billing@startupxyz.de'
        },
        {
            id: 5,
            name: 'Digital Agency Pro',
            address: '654 Creative District',
            country: 'Australia',
            tax_id: 'AU123789456',
            vat_number: 'AU456123789',
            email: 'finance@digitalagencypro.au'
        }
    ]);
    const itemsPerPage = 5;

    // New invoice form state
    const [newInvoice, setNewInvoice] = useState({
        invoice_id: `INV${new Date().getFullYear()}`,
        invoice_nr: '001',
        client_id: '',
        client_name: '',
        client_address: '',
        client_country: '',
        tax_id: '',
        vat_number: '',
        email_address: '',
        issue_date: formatDate(new Date()),
        due_date: getNextMonthDate(),
        delivery_date: formatDate(new Date()),
        items: [{
            id: 1,
            name: `Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        }],
        status: 'draft'
    });

    // Utility functions
    function formatDate(date) {
        const day = date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate();
        const month = (date.getUTCMonth() + 1) < 10 ? "0" + (date.getUTCMonth() + 1) : (date.getUTCMonth() + 1);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    function getNextMonthDate() {
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        const lastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0).getDate();
        return formatDate(new Date(nextMonth.getFullYear(), nextMonth.getMonth(), lastDay));
    }

    function getPreviousBusinessDay() {
        const today = new Date();
        let previousDay = new Date(today);
        previousDay.setDate(today.getDate() - 1);
        
        // If yesterday was Sunday (0) or Saturday (6), go to Friday
        while (previousDay.getDay() === 0 || previousDay.getDay() === 6) {
            previousDay.setDate(previousDay.getDate() - 1);
        }
        
        return formatDate(previousDay);
    }
useEffect(() => {
        socket.on('response_get_admin_invoices', (data) => {
            setInvoiceClients(data.invoiceClients)
            setInvoices(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            setRank(data.rank)
            setSelectedInvoice(data.withdrawals.length-1)
            setAlert2({...alert2,
                invoice_id:`INV${new Date().getFullYear()}`,
                invoice_nr: invoices[0]==undefined?'034':invoices[0].invoice_nr==undefined?'034':invoices[0].invoice_nr.includes('0')?'0'+(parseInt(invoices[0].invoice_nr.split('0')[1])+1):(parseInt(invoices[0].invoice_nr.split('0')[1])+1),
                issue_date: ((new Date().getUTCDate()<10)?"0"+new Date().getUTCDate():new Date().getUTCDate())+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                due_date: (getNextMonthLastDay())+'/'+((new Date().getUTCMonth()+2)<10?"0"+(new Date().getUTCMonth()+2):(new Date().getUTCMonth()+2))+'/'+new Date().getFullYear(),
                delivery_date: ((new Date().getUTCDate()<10)?"0"+new Date().getUTCDate():new Date().getUTCDate())+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                client_name: '',
                client_address: '',
                client_country: '',
                tax_id: '',
                vat_number: '',
                email_address: '',
                item_name:`Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
                items_price:0,
                item_quantity:1,
                item_currency:'USD',
                item_exchange:0,
                item_exchange_to:'RON',
                item_exchange_date:(((new Date().getUTCDate()-1)<10)?"0"+(new Date().getUTCDate()-1):(new Date().getUTCDate()-1))+'/'+((new Date().getUTCMonth()+1)<10?"0"+(new Date().getUTCMonth()+1):(new Date().getUTCMonth()+1))+'/'+new Date().getFullYear(),
                item_id:1

            })
         
        })
        socket.emit('getAdminInvoices', {
            offers_like: username,
            type,
            page:page,
        })

    }, [])
    function generateNextInvoiceNumber() {
        if (invoices.length === 0) return '001';
        
        const lastInvoice = invoices[0];
        if (!lastInvoice || !lastInvoice.invoice_nr) return '001';
        
        const lastNumber = parseInt(lastInvoice.invoice_nr);
        const nextNumber = lastNumber + 1;
        return nextNumber.toString().padStart(3, '0');
    }

    // Fetch exchange rates from BNR
   

    // Handle client selection
    const handleClientSelect = (clientId, invoice, setInvoice) => {
        const selectedClient = invoiceClients.find(client => client.id === parseInt(clientId));
        if (selectedClient) {
            setInvoice({
                ...invoice,
                client_id: clientId,
                client_name: selectedClient.client_name,
                client_address: selectedClient.client_address,
                client_country: selectedClient.client_country,
                tax_id: selectedClient.tax_id,
                vat_number: selectedClient.vat_number,
                email_address: selectedClient.email
            });
        } else {
            // Clear client fields when no client is selected
            setInvoice({
                ...invoice,
                client_id: '',
                client_name: '',
                client_address: '',
                client_country: '',
                tax_id: '',
                vat_number: '',
                email_address: ''
            });
        }
    };

    // Handle items management
    const addItem = (invoice, setInvoice) => {
        const newItemId = Math.max(...invoice.items.map(item => item.id), 0) + 1;
        const newItem = {
            id: newItemId,
            name: `Service ${newItemId}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        };
        
        setInvoice({
            ...invoice,
            items: [...invoice.items, newItem]
        });
    };

    const removeItem = (itemId, invoice, setInvoice) => {
        if (invoice.items.length > 1) {
            setInvoice({
                ...invoice,
                items: invoice.items.filter(item => item.id !== itemId)
            });
        }
    };

    const updateItem = (itemId, field, value, invoice, setInvoice) => {
        setInvoice({
            ...invoice,
            items: invoice.items.map(item => 
                item.id === itemId 
                    ? { ...item, [field]: value }
                    : item
            )
        });
    };
    useEffect(() => {
        
        // Update new invoice number
        setNewInvoice(prev => ({
            ...prev,
            invoice_nr: generateNextInvoiceNumber()
        }));
    }, [invoices]);

    // Filtered invoices based on search and status
    const filteredInvoices = invoices.filter(invoice => {
        const matchesSearch = invoice.client_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            invoice.invoice_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            invoice.invoice_nr.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === 'all' || invoice.status === statusFilter;
        return matchesSearch && matchesStatus;
    });

    // Pagination calculations
    const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentInvoices = filteredInvoices.slice(startIndex, endIndex);

    // Reset to first page when search changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, statusFilter]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // Create new invoice
   const handleCreateInvoice = () => {
    const invoice = {
        id: Math.max(...invoices.map(i => i.id), 0) + 1,
        invoice_id: newInvoice.invoice_id,
        invoice_nr: newInvoice.invoice_nr,
        client_name: newInvoice.client_name,
        client_address: newInvoice.client_address,
        client_country: newInvoice.client_country,
        tax_id: newInvoice.tax_id,
        vat_number: newInvoice.vat_number,
        email_address: newInvoice.email_address,
        issue_date: newInvoice.issue_date,
        due_date: newInvoice.due_date,
        delivery_date: newInvoice.delivery_date,
        items: newInvoice.items.map(item => ({
            ...item,
            exchange: exchangeRates[item.currency] || item.exchange
        })),
        status: newInvoice.status
    };

    // Emit socket event for adding invoice
    socket.emit('adminAction', {
        action: "add_invoice",
        page: page,
        show: true,
        name: "",
        reward: 0,
        invoice_id: newInvoice.invoice_id,
        invoice_nr: newInvoice.invoice_nr,
        client_address: newInvoice.client_address,
        client_country: newInvoice.client_country,
        client_id: newInvoice.client_id,
        client_name: newInvoice.client_name,
        delivery_date: newInvoice.delivery_date,
        due_date: newInvoice.due_date,
        email_address: newInvoice.email_address,
        id: invoice.id,
        issue_date: newInvoice.issue_date,
        item_currency: newInvoice.items[0].currency,
        item_exchange: newInvoice.items[0].exchange,
        item_exchange_date: newInvoice.items[0].exchange_date,
        item_exchange_to: newInvoice.items[0].exchange_to,
        item_id: newInvoice.items[0].id,
        item_name: newInvoice.items[0].name,
        item_quantity: newInvoice.items[0].quantity,
        items_price: newInvoice.items[0].price,
        tax_id: newInvoice.tax_id,
        vat_number: newInvoice.vat_number
    });

    setInvoices([invoice, ...invoices]);
    setShowCreateModal(false);
    
    // Reset form for next invoice
    setNewInvoice({
        ...newInvoice,
        invoice_nr: (parseInt(newInvoice.invoice_nr) + 1).toString().padStart(3, '0'),
        client_id: '',
        client_name: '',
        client_address: '',
        client_country: '',
        tax_id: '',
        vat_number: '',
        email_address: '',
        items: [{
            id: 1,
            name: `Marketing Services for ${months[new Date().getUTCMonth()]} ${new Date().getFullYear()}`,
            quantity: 1,
            price: 0,
            currency: 'USD',
            exchange: 0,
            exchange_to: 'RON',
            exchange_date: getPreviousBusinessDay()
        }]
    });
};

    // Edit invoice
    const handleEditInvoice = (invoice) => {
        setEditingInvoice({
            ...invoice,
            client_id: invoiceClients.find(client => client.name === invoice.client_name)?.id || ''
        });
        setShowEditModal(true);
    };

    const handleSaveEdit = () => {
        const updatedInvoice = {
            ...editingInvoice,
            items: editingInvoice.items.map(item => ({
                ...item,
                exchange: item.exchange
            }))
        };

        setInvoices(invoices.map(inv => inv.id === editingInvoice.id ? updatedInvoice : inv));
        setShowEditModal(false);
        setEditingInvoice(null);
    };

    function generatePDF(name) {
        // We'll use jsPDF for simplicity
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF("portrait", "pt", "a4");
        let width = doc.internal.pageSize.getWidth();
        let height = doc.internal.pageSize.getHeight();
    
        doc.html(document.querySelector(".invoice-container"), {
          x: 20, // Adjust X and Y offsets for desired positioning
          y: 20,
          html2canvas: {
            scale: 0.85,
          },
          callback: function (pdf) {
            pdf.save(`${name}.pdf`);
          },
        });
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'paid': return 'bg-green-500';
            case 'pending': return 'bg-yellow-500';
            case 'overdue': return 'bg-red-500';
            case 'draft': return 'bg-gray-500';
            default: return 'bg-gray-500';
        }
    };

    const numberWithCommas = (num) => {
        return parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const totalRevenue = filteredInvoices.reduce((sum, invoice) => {
        return sum + invoice.items.reduce((itemSum, item) => itemSum + (item.quantity * item.price), 0);
    }, 0);


    return (
        <div className="min-h-screen bg-gray-900 text-white">
            {/* Header Stats */}
            <div className="bg-gray-800 border-b border-gray-700 p-6">
                <div className="mx-auto">
                    <h1 className="text-3xl font-bold text-white mb-6">Invoice Management</h1>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div className="bg-gray-700 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-300 text-sm">Total Invoices</p>
                                    <p className="text-2xl font-bold text-white">{filteredInvoices.length}</p>
                                </div>
                                <FileText className="w-8 h-8 text-blue-400" />
                            </div>
                        </div>
                        <div className="bg-gray-700 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-300 text-sm">Total Revenue</p>
                                    <p className="text-2xl font-bold text-white">${numberWithCommas(totalRevenue)}</p>
                                </div>
                                <DollarSign className="w-8 h-8 text-green-400" />
                            </div>
                        </div>
                        <div className="bg-gray-700 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-300 text-sm">Paid Invoices</p>
                                    <p className="text-2xl font-bold text-white">{invoices.filter(i => i.status === 'paid').length}</p>
                                </div>
                                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                            </div>
                        </div>
                        <div className="bg-gray-700 rounded-lg p-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-gray-300 text-sm">Pending</p>
                                    <p className="text-2xl font-bold text-white">{invoices.filter(i => i.status === 'pending').length}</p>
                                </div>
                                <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto p-6">
                <div className="gap-6">
                    {/* Invoice List */}
                    <div className="lg:col-span-2">
                        <div className="bg-gray-800 rounded-lg shadow-lg">
                            {/* Search and Filters */}
                            <div className="p-6 border-b border-gray-700">
                                <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
                                    <div className="relative flex-1 max-w-md">
                                        <Search className="absolute left-3 top-1/3 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                                        <input
                                            type="text"
                                            placeholder="Search invoices..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="w-full pl-10 pr-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        />
                                    </div>
                                    <div className="flex gap-3">
                                        <button
                                            onClick={() => setShowCreateModal(true)}
                                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-medium transition-colors"
                                        >
                                            <Plus className="w-4 h-4" />
                                            New Invoice
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Invoice Table */}
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead className="bg-gray-700">
                                        <tr>
                                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Invoice</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Client</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Amount</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Status</th>
                                            <th className="px-6 py-4 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-700">
                                        {currentInvoices.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-8 text-center text-gray-400">
                                                    No invoices found
                                                </td>
                                            </tr>
                                        ) : (
                                            currentInvoices.map((invoice, index) => (
                                                <tr 
                                                    key={invoice.id}
                                                    className={`hover:bg-gray-750 cursor-pointer transition-colors ${
                                                        selectedInvoice === startIndex + index ? 'bg-gray-750 ring-1 ring-blue-500' : ''
                                                    }`}
                                                    onClick={() => setSelectedInvoice(startIndex + index)}
                                                >
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm font-medium text-white">
                                                            {invoice.invoice_id}{invoice.invoice_nr}
                                                        </div>
                                                        <div className="text-sm text-gray-400">{invoice.issue_date}</div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm text-white">{invoice.client_name}</div>
                                                        <div className="text-sm text-gray-400">{invoice.client_country}</div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm font-medium text-white">
                                                            {invoice.items[0].currency} {numberWithCommas(invoice.items[0].price)}
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${getStatusColor(invoice.status)} text-white`}>
                                                            {invoice.status}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                        <div className="flex gap-2">
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedInvoice(startIndex + index);
                                                                }}
                                                                className="text-blue-400 hover:text-blue-300 transition-colors"
                                                                title="View"
                                                            >
                                                                <Eye className="w-4 h-4" />
                                                            </button>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleEditInvoice(invoice);
                                                                }}
                                                                className="text-yellow-400 hover:text-yellow-300 transition-colors"
                                                                title="Edit"
                                                            >
                                                                <Edit className="w-4 h-4" />
                                                            </button>
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    generatePDF(`${invoice.invoice_id}${invoice.invoice_nr}`);
                                                                }}
                                                                className="text-green-400 hover:text-green-300 transition-colors"
                                                                title="Download PDF"
                                                            >
                                                                <Download className="w-4 h-4" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <div className="px-6 py-4 border-t border-gray-700">
                                <div className="flex items-center justify-between">
                                    <div className="text-sm text-gray-400">
                                        Showing {startIndex + 1} to {Math.min(endIndex, filteredInvoices.length)} of {filteredInvoices.length} results
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <button
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className="p-2 rounded-lg bg-gray-700 text-gray-300 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                        >
                                            <ChevronLeft className="w-4 h-4" />
                                        </button>
                                        
                                        {[...Array(totalPages)].map((_, index) => {
                                            const page = index + 1;
                                            return (
                                                <button
                                                    key={page}
                                                    onClick={() => handlePageChange(page)}
                                                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                                                        currentPage === page
                                                            ? 'bg-blue-600 text-white'
                                                            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                                    }`}
                                                >
                                                    {page}
                                                </button>
                                            );
                                        })}
                                        
                                        <button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="p-2 rounded-lg bg-gray-700 text-gray-300 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                        >
                                            <ChevronRight className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Invoice Preview */}
                {invoices[selectedInvoice].items==undefined?'':    <div className="lg:col-span-1 mt-4" >
                        <div className="bg-gray-800 overflow-x-auto rounded-lg shadow-lg p-6 sticky top-6">
                            <h3 className="text-lg font-semibold text-white mb-4">Invoice Preview</h3>
                            {filteredInvoices[selectedInvoice] && (
                                <div className="container-inv" style={{ letterSpacing: "10px" }}>
                                      <div
          className="invoice-container"
          id="frame"
          frameBorder={0}
          sandbox="allow-same-origin"
          style={{ letterSpacing: "0.9px" }}
        >
          <div id="header-inv">
            <div>
              <h1>
                Invoice &nbsp;{invoices[selectedInvoice].invoice_id}
                {invoices[selectedInvoice].invoice_nr}
              </h1>
              <div className="invoice-short-info">
                <dt className="label">Issue date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].issue_date}
                </dd>
                <dt className="label">Due date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].due_date}
                </dd>
                <dt className="label">Delivery date:</dt>
                <dd className="text-black">
                  {invoices[selectedInvoice].delivery_date}
                </dd>
              </div>
            </div>
          </div>
          <table className="bodypart-inv">
            <thead>
              <tr>
                <td>
                  <div id="header-inv-space">&nbsp;</div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {/* Issuer and recipient info */}
                  <div className="issuer-recipient-block">
                    <div>
                      {/* Issuer info */}
                      <div className="label">Issuer</div>
                      <div className="address-block">
                        <div className="title">
                          LOMORA LAURENTIU PERSOANA FIZICA AUTORIZATA
                        </div>
                        <div>
                          <span>Cal. Chisinaului, Nr. 22H, Bl. C2, Sc. D, Et. 11 Ap. 69</span>
                        </div>
                        <div>
                          <span>700264 </span>
                          Mun. Iasi
                        </div>
                        <div>Iasi</div>
                        <div>Romania</div>
                      </div>
                      <div>
                        <span className="label">Commercee number:</span>{" "}
                        F4/81/2021
                      </div>
                      <div>
                        <span className="label">TAX ID:</span> RO43681925
                      </div>
                      <div>
                        <span className="label">Phone number:</span> 0753461170
                      </div>
                      <div>
                        <span className="label">E-mail:</span>
                        lomoralaurentiu1@gmail.com
                      </div>
                    </div>
                    <div>
                      {/* Recipient info */}
                      <div className="label">Client</div>
                      <div className="address-block">
                        <div className="title">
                          {invoices[selectedInvoice].client_name}
                        </div>
                        <div>
                          <span>
                            {invoices[selectedInvoice].client_address}
                          </span>
                        </div>
                        {/* <div>Lisboa</div> */}
                        <div>
                          {invoices[selectedInvoice].client_country}
                        </div>
                      </div>
                      <div>
                        <span className="label">TAX ID:</span>{" "}
                        {invoices[selectedInvoice].tax_id}
                      </div>
                      {invoices[selectedInvoice].vat_number == "" ? (
                        ""
                      ) : (
                        <div>
                          <span className="label">VAT Number:</span>{" "}
                          {invoices[selectedInvoice].vat_number}
                        </div>
                      )}
                      <div>
                        {invoices[selectedInvoice].email_address ==
                        "" ? (
                          ""
                        ) : (
                          <>
                            <span className="label">E-mail:</span>
                            {invoices[selectedInvoice].email_address}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="payment-info-title">Payment info</div>
                  <div className="payment-info">
                    <div className="payment-info-left">
                      <div className="payment-info-rows">
                        <div>
                          <span className="label">IBAN / Account number:</span>
                          RO90RNCB0029169283620001
                        </div>
                        <div>
                          <span className="label">Bank name:</span> Banca
                          Comerciala Romana
                        </div>
                        <div>
                          <span className="label">SWIFT / BIC code:</span>{" "}
                          RNCBROBUXXX
                        </div>
                        <div>
                          <span className="label">Payment description:</span>
                          {invoices[selectedInvoice].invoice_id}
                          {invoices[selectedInvoice].invoice_nr}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Items */}
                  <table className="header-rounded-corners invoice-items">
                    <thead>
                      <tr className="purple-bg">
                        <th>Item name</th>
                        <th style={{ width: "16%" }}>Quantity</th>
                        <th style={{ width: "16%" }}>Units</th>
                        <th style={{ width: "16%" }}>
                          <span>Unit price</span>,{" "}
                          {invoices[selectedInvoice].items[0].currency}
                        </th>
                        <th style={{ width: "12%" }}>
                          <span>Subtotal</span>,{" "}
                          {invoices[selectedInvoice].items[0].currency}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoices[selectedInvoice].items.map((item) => {
                        return (
                          <tr className='invoice-item'>
                            <td>
                              <div>{item.name}</div>
                            </td>
                            <td>{item.quantity}</td>
                            <td />
                            <td>{numberWithCommas(item.price)}</td>
                            <td>
                              {numberWithCommas(item.quantity * item.price)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {/*Summary and additional info*/}
                  <div className="summary-additional-info">
                    {/*Additional info*/}
                    <div />
                    {/*Summary*/}
                    <div>
                      <div className="summary-table">
                        <div className="total-amount-item">
                          <div className="total-amount">Total:</div>
                          <div className="total-amount">
                            {
                              invoices[selectedInvoice].items[0]
                                .currency
                            }
                            &nbsp;
                            {numberWithCommas(
                              invoices[selectedInvoice].items
                                .map((item) => item.quantity * item.price)
                                .reduce((a, b) => a + b, 0)
                                .toFixed(2)
                            )}
                          </div>
                        </div>
                        <div className="exchange-rate-item">
                          <div>
                            1{" "}
                            {
                              invoices[selectedInvoice].items[0]
                                .currency
                            }{" "}
                            ={" "}
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_to
                            }
                            &nbsp;
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange
                            }
                          </div>
                          <div>
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_to
                            }
                            &nbsp;
                            {numberWithCommas(
                              parseFloat(
                                invoices[selectedInvoice].items
                                  .map((item) => item.quantity * item.price)
                                  .reduce((a, b) => a + b, 0)
                                  .toFixed(2) *
                                  invoices[selectedInvoice].items[0]
                                    .exchange
                              ).toFixed(2)
                            )}
                          </div>
                        </div>
                        <div className="exchange-rate-item">
                          <div>Exchange date:</div>
                          <div>
                            {
                              invoices[selectedInvoice].items[0]
                                .exchange_date
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div id="footer-inv-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
          <div id="footer-inv">
            <div className="footer-left">
              <div>
                The invoice is valid without signature and stamp, according to
                art. 319 paragraph (29) of Law no. 227/2015 regarding the Fiscal
                Code.
              </div>
              <div>
                VAT exempted, as per art. 310 of Law 227/2015 regarding the
                Fiscal Code.
              </div>
            </div>
          </div>
        </div>

                                    <button
                                        onClick={() => generatePDF(`${filteredInvoices[selectedInvoice].invoice_id}${filteredInvoices[selectedInvoice].invoice_nr}`)}
                                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-white font-medium transition-colors"
                                    >
                                        <Download className="w-4 h-4" />
                                        Download PDF
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>}
            </div>

            {/* Create Invoice Modal */}

            {showCreateModal && (
               <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-gray-700">
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-semibold text-white">{'Create invoice'}</h2>
                        <button
                            type="button"
                            onClick={(e)=>{setShowCreateModal(false)}}
                            className="text-gray-400 hover:text-white transition-colors"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>
                
                <div onSubmit={(e) => e.preventDefault()}>
                    <div className="p-6 space-y-6">
                        {/* Invoice Info */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-300 mb-1">Invoice ID</label>
                                <input
                                    type="text"
                                    value={newInvoice.invoice_id}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, invoice_id: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-300 mb-1">Invoice Number</label>
                                <input
                                    type="text"
                                    value={newInvoice.invoice_nr}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, invoice_nr: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                                />
                            </div>
                        </div>

                        {/* Client Selection */}
                        <div className="bg-gray-700 rounded-lg p-4">
                            <h3 className="text-lg font-medium text-white mb-4">Client Information</h3>
                            
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-300 mb-1">Select Existing Client</label>
                                <select
                                    value={newInvoice.client_id || ''}
                                    onChange={(e) => handleClientSelect(e.target.value, newInvoice, setNewInvoice)}
                                    className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                >
                                    <option value="">Select a client or enter manually</option>
                                    {invoiceClients.map(client => (
                                        <option key={client.id} value={client.id}>
                                            {client.client_name} - {client.client_country}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-300 mb-1">Client Name</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_name}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_name: e.target.value })}
                                        className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-300 mb-1">Client Address</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_address}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_address: e.target.value })}
                                        className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-300 mb-1">Country</label>
                                    <input
                                        type="text"
                                        value={newInvoice.client_country}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, client_country: e.target.value })}
                                        className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-300 mb-1">Tax ID</label>
                                    <input
                                        type="text"
                                        value={newInvoice.tax_id}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, tax_id: e.target.value })}
                                        className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-300 mb-1">VAT Number</label>
                                    <input
                                        type="text"
                                        value={newInvoice.vat_number}
                                        onChange={(e) => setNewInvoice({ ...newInvoice, vat_number: e.target.value })}
                                        className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                    />
                                </div>
                            </div>

                            <div className="mt-4">
                                <label className="block text-sm font-medium text-gray-300 mb-1">Email</label>
                                <input
                                    type="email"
                                    value={newInvoice.email_address}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, email_address: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-600 border border-gray-500 rounded-lg text-white"
                                />
                            </div>
                        </div>

                        {/* Dates */}
                        <div className="grid grid-cols-3 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-300 mb-1">Issue Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.issue_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, issue_date: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-300 mb-1">Due Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.due_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, due_date: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-300 mb-1">Delivery Date</label>
                                <input
                                    type="text"
                                    value={newInvoice.delivery_date}
                                    onChange={(e) => setNewInvoice({ ...newInvoice, delivery_date: e.target.value })}
                                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                                />
                            </div>
                        </div>

                        {/* Items Section */}
                        <div className="bg-gray-700 rounded-lg p-4">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-lg font-medium text-white">Invoice Items</h3>
                                <button
                                    type="button"
                                    onClick={() => addItem(newInvoice, setNewInvoice)}
                                    className="flex items-center gap-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded text-white text-sm transition-colors"
                                >
                                    <Plus className="w-4 h-4" />
                                    Add Item
                                </button>
                            </div>

                            <div className="space-y-4">
                                {newInvoice.items && newInvoice.items.map((item, index) => (
                                    <div key={item.id || index} className="bg-gray-600 rounded-lg p-4">
                                        <div className="flex items-center justify-between mb-3">
                                            <h4 className="text-white font-medium">Item {index + 1}</h4>
                                            {newInvoice.items.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeItem(item.id || index, newInvoice, setNewInvoice)}
                                                    className="text-red-400 hover:text-red-300 transition-colors"
                                                >
                                                    <X className="w-4 h-4" />
                                                </button>
                                            )}
                                        </div>

                                        <div className="space-y-3">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-1">Item Name</label>
                                                <input
                                                    type="text"
                                                    value={item.name || ''}
                                                    onChange={(e) => updateItem(item.id || index, 'name', e.target.value, newInvoice, setNewInvoice)}
                                                    className="w-full px-3 py-2 bg-gray-500 border border-gray-400 rounded-lg text-white"
                                                />
                                            </div>

                                            <div className="grid grid-cols-4 gap-3">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-300 mb-1">Quantity</label>
                                                    <input
                                                        type="number"
                                                        value={item.quantity || 1}
                                                        onChange={(e) => updateItem(item.id || index, 'quantity', parseInt(e.target.value) || 1, newInvoice, setNewInvoice)}
                                                        className="w-full px-3 py-2 bg-gray-500 border border-gray-400 rounded-lg text-white"
                                                        min="1"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-300 mb-1">Price</label>
                                                    <input
                                                        type="number"
                                                        value={item.price || 0}
                                                        onChange={(e) => updateItem(item.id || index, 'price', parseFloat(e.target.value) || 0, newInvoice, setNewInvoice)}
                                                        className="w-full px-3 py-2 bg-gray-500 border border-gray-400 rounded-lg text-white"
                                                        min="0"
                                                        step="0.01"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-300 mb-1">Currency</label>
                                                    <select
                                                        value={item.currency || 'USD'}
                                                        onChange={(e) => updateItem(item.id || index, 'currency', e.target.value, newInvoice, setNewInvoice)}
                                                        className="w-full px-3 py-2 bg-gray-500 border border-gray-400 rounded-lg text-white"
                                                    >
                                                        <option value="USD">USD</option>
                                                        <option value="EUR">EUR</option>
                                                        <option value="GBP">GBP</option>
                                                        <option value="RON">RON</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-300 mb-1">Exchange</label>
                                                    <input
                                                        type="number"
                                                        value={item.exchange || 1}
                                                        onChange={(e) => updateItem(item.id || index, 'exchange', parseFloat(e.target.value) || 1, newInvoice, setNewInvoice)}
                                                        className="w-full px-3 py-2 bg-gray-500 border border-gray-400 rounded-lg text-white"
                                                        min="0"
                                                        step="0.01"
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex justify-between items-center text-sm">
                                                <span className="text-gray-300">
                                                    Exchange Rate: 1 {item.currency} = {item.exchange || exchangeRates[item.currency] || 'N/A'} RON
                                                </span>
                                                <span className="text-white font-medium">
                                                    Subtotal: {item.currency} {numberWithCommas((item.quantity || 1) * (item.price || 0))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Total */}
                            <div className="mt-4 pt-4 border-t border-gray-600">
                                <div className="flex justify-end">
                                    <div className="text-right">
                                        <div className="text-lg font-semibold text-white">
                                            Total: {newInvoice.items && newInvoice.items.length > 0 ? newInvoice.items[0].currency : 'USD'} {
                                                newInvoice.items ? numberWithCommas(
                                                    newInvoice.items.reduce((sum, item) => sum + ((item.quantity || 1) * (item.price || 0)), 0)
                                                ) : '0.00'
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-1">Status</label>
                            <select
                                value={newInvoice.status}
                                onChange={(e) => setNewInvoice({ ...newInvoice, status: e.target.value })}
                                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white"
                            >
                                <option value="draft">Draft</option>
                                <option value="pending">Pending</option>
                                <option value="paid">Paid</option>
                                <option value="overdue">Overdue</option>
                            </select>
                        </div>
                    </div>

                    <div className="p-6 border-t border-gray-700 flex gap-3 justify-end">
                        <button
                            type="button"
                            onClick={(e)=>{setShowCreateModal(false)}}
                            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-lg text-white transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleCreateInvoice}
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white transition-colors"
                        >
                            {false==true ? 'Save Changes' : 'Create Invoice'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
            )}
{console.log(showCreateModal)}
            {/* Edit Invoice Modal */}
            {/* <InvoiceModal
                show={showEditModal}
                onClose={() => {
                    setShowEditModal(false);
                    setEditingInvoice(null);
                }}
                title="Edit Invoice"
                invoice={editingInvoice || {}}
                onChange={setEditingInvoice}
                onSave={handleSaveEdit}
                isEdit={true}
            /> */}
        </div>
    );
}

export default ProfessionalInvoiceManager;